import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Stack,
  Paper,
  Button,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Dialog,
  useMediaQuery,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import DataTable from "../../DataTable/index";
import CALC_ICON from "../../../assets/images/calc.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "react-circular-progressbar/dist/styles.css";
import MainModal from "../../MainModal/index";
import { useDispatch, useSelector } from "react-redux";
import { getPlayerScore } from "../../../redux/actions/player-area-action/player-scores-action";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { borderRadius, width } from "@mui/system";
import ProfileInfo from "../ProfileInfo";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  modal: {
    // width: "100%",
    // border: "1px solid #000",
    boxShadow: 24,
    padding: "25px !important",
    // backgroundColor: "#ebebeb",
  },
}));
function createData(name) {
  return { name };
}

var rowsP1 = [];
for (var i = 1; i <= 21; i++) {
  rowsP1.push(i);
}

const rows = [
  createData("Holes"),
  createData("Index"),
  createData("Par"),
  createData("Strokes"),
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
    borderTop: "1px dashed black",
    borderBottom: "1px dashed black",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: "10px",
  border: "none",
  textAlign: "center",
}));

const empty = [
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
  "-",
];
const parValues = [
  4, 5, 4, 3, 5, 4, 4, 3, 4, 36, 5, 3, 4, 4, 5, 4, 3, 4, 4, 36, 72,
];
const strokesValues = [
  5, 5, 4, 6, 5, 6, 5, 4, 3, 43, 2, 3, 3, 5, 5, 5, 5, 5, 6, 39, 83,
];

const ScoreDetailsModal = (props) => {
  const score = props.score;

  const resData = {
    event_name: score?.event_name ? score?.event_name : "Additional Scorecard",
    date: score?.date ? moment(score?.date).format("lll") : "",
    course_name: score?.course_name ? score?.course_name : "Golf Course",
    index: score?.index ? score?.index : empty,
    par: score?.par ? score?.par : empty,
    strokes: score?.strokes ? score?.strokes : empty,
  };

  const [strokeIn, setStrokeIn] = useState(0);
  const [strokeOut, setStrokeOut] = useState(0);
  const [parOut, setParOut] = useState(0);
  const [parIn, setParIn] = useState(0);
  const [strokeTotal] = useState(score?.score);

  useEffect(() => {
    let sumParIn = 0;
    let sumParOut = 0;

    let sumStrokesIn = 0;
    let sumStrokesOut = 0;

    for (let a = 0; a < score?.index?.length; a++) {
      if (a < 9) {
        sumParOut += score.par[a];
        sumStrokesOut += score.strokes[a];
      } else {
        sumParIn += score.par[a];
        sumStrokesIn += score.strokes[a];
      }
      setParIn(sumParIn);
      setParOut(sumParOut);

      setStrokeIn(sumStrokesIn);
      setStrokeOut(sumStrokesOut);
    }
  }, [score]);

  useEffect(() => {
    return () => {
      props.setScore({});
    };
  }, []);

  const classes = useStyles();

  return (
    <Dialog
      open={props.handleOpenModal}
      onClose={props.handleCloseModal}
      maxWidth="xl"
    >
      <Box className={classes.modal}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Scorecard Details</Typography>
          <CancelOutlinedIcon
            sx={{ cursor: "pointer" }}
            onClick={props.handleCloseModal}
          />
        </Box>
        <Grid container mt={2}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-around",
              backgroundColor: "#C4C4C41A",
              padding: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              fontSize={{ xs: "10px", md: "16px" }}
              fontWeight={700}
            >
              {resData.event_name}
            </Typography>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              fontSize={{ xs: "10px", md: "16px" }}
            >
              {resData.date}
            </Typography>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              fontSize={{ xs: "10px", md: "16px" }}
            >
              {resData.course_name}
            </Typography>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell sx={{ textAlign: "left", padding: "0 35px" }}>
                  Holes
                </StyledTableCell>
                {rowsP1.map((x, i) =>
                  i < 9 ? (
                    <StyledTableCell>{x}</StyledTableCell>
                  ) : i == 9 ? (
                    <StyledTableCell>OUT</StyledTableCell>
                  ) : i == 19 ? (
                    <StyledTableCell>IN</StyledTableCell>
                  ) : i == 20 ? (
                    <StyledTableCell>TOTAL</StyledTableCell>
                  ) : (
                    <StyledTableCell>{x - 1}</StyledTableCell>
                  )
                )}
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell sx={{ textAlign: "left", padding: "0 35px" }}>
                  Index
                </StyledTableCell>
                {rowsP1.map((x, i) =>
                  i < 9 ? (
                    <StyledTableCell>{resData.index[i]}</StyledTableCell>
                  ) : i == 9 ? (
                    <StyledTableCell>
                      {/* {score?.index ? indexOut : "-"} */}
                    </StyledTableCell>
                  ) : i == 19 ? (
                    <StyledTableCell>
                      {/* {score?.index ? indexIn : "-"} */}
                    </StyledTableCell>
                  ) : i == 20 ? (
                    <StyledTableCell>
                      {/* {score?.index ? indexIn + indexOut : "-"} */}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>{resData.index[i - 1]}</StyledTableCell>
                  )
                )}
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell sx={{ textAlign: "left", padding: "0 35px" }}>
                  Par
                </StyledTableCell>
                {rowsP1.map((x, i) =>
                  i < 9 ? (
                    <StyledTableCell>{resData.par[i]}</StyledTableCell>
                  ) : i == 9 ? (
                    <StyledTableCell>
                      {score?.par ? parOut : "-"}
                    </StyledTableCell>
                  ) : i == 19 ? (
                    <StyledTableCell>
                      {score?.par ? parIn : "-"}
                    </StyledTableCell>
                  ) : i == 20 ? (
                    <StyledTableCell>
                      {score?.par ? parIn + parOut : "-"}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>{resData.par[i - 1]}</StyledTableCell>
                  )
                )}
              </StyledTableRow>
              <StyledTableRow style={{ borderTop: "1.5px solid #06623B" }}>
                <StyledTableCell sx={{ textAlign: "left", padding: "0 35px" }}>
                  Strokes
                </StyledTableCell>
                {resData.strokes?.map((x, i) => {
                  let strokeSumBogey = resData.par[i] + 1;
                  let strokeSumDobleBogey = resData.par[i] + 2;
                  let strokeSumBirdy = resData.par[i] - 1;
                  let strokeSumEagleOrBetter = resData.par[i] - 2;

                  if (i < 9) {
                    if (x > resData.par[i] && x == strokeSumBogey) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#0C2DD8",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (x > resData.par[i] && x >= strokeSumDobleBogey) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#000000",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (x < resData.par[i] && x == strokeSumBirdy) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#FF0000",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (
                      x < resData.par[i] &&
                      x <= strokeSumEagleOrBetter
                    ) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#FFC700",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else {
                      return (
                        <StyledTableCell>
                          <Typography sx={{ padding: "1px 8px" }}>
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    }
                  } else if (i === 9) {
                    return (
                      <>
                        <StyledTableCell>
                          {score?.strokes ? strokeOut : "-"}
                        </StyledTableCell>
                        <StyledTableCell>{x}</StyledTableCell>
                      </>
                    );
                  } else if (i > 9) {
                    if (x > resData.par[i] && x == strokeSumBogey) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#0C2DD8",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (x > resData.par[i] && x >= strokeSumDobleBogey) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#000000",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (x < resData.par[i] && x == strokeSumBirdy) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#FF0000",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else if (
                      x < resData.par[i] &&
                      x <= strokeSumEagleOrBetter
                    ) {
                      return (
                        <StyledTableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#FFC700",
                              color: "#FFF",
                              padding: "1px 8px",
                            }}
                          >
                            {x}
                          </Typography>
                        </StyledTableCell>
                      );
                    } else {
                      // console.log("x", i);
                      return (
                        <StyledTableCell>
                          <Typography sx={{ padding: "1px 8px" }}>
                            {i === 19 ? strokeTotal : x}
                          </Typography>
                        </StyledTableCell>
                      );
                    }
                  }
                })}

                {score?.strokes && (
                  <>
                    <StyledTableCell
                      sx={{ textAlign: "left", padding: "0 35px" }}
                    >
                      {strokeIn}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ textAlign: "left", padding: "0 35px" }}
                    >
                      {strokeIn + strokeOut}
                    </StyledTableCell>
                  </>
                )}
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Grid container>
          <Grid
            item
            xs={12}
            lg={8}
            sx={{
              marginLeft: "auto",
              marginTop: "20px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={4} md={2.5}>
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    sx={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#FF0000",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography fontSize={{ xs: "10px", md: "14px" }}>
                    Birdie
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={2.5}>
                <Box
                  display={"flex"}
                  // justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#FFC700",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography fontSize={{ xs: "10px", md: "14px" }}>
                    Eagle or Better
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={2.5}>
                <Box
                  display={"flex"}
                  // justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#0C2DD8",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography fontSize={{ xs: "10px", md: "14px" }}>
                    Bogey
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4.5}>
                <Box
                  display={"flex"}
                  // justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#000000",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography fontSize={{ xs: "10px", md: "14px" }}>
                    Double Bogey or Worse
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid container mt={1}>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
          ></Grid>
        </Grid> */}
      </Box>
    </Dialog>
  );
};

export default ScoreDetailsModal;
